import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FavoriteListsComponent } from './favorite-lists.component';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.favoriteLists.pageInRouting,
    data: { data: PAGES_AND_PATHS.favoriteLists },
    component: FavoriteListsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./favorite-lists.module').then(m => m.FavoriteListsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FavoriteListsRoutingModule { }
